import { ErrorAlert } from '@/components/_ui/ErrorAlert'
import type { CosmicBannerDataType } from '@/lib/cms/cosmic/types/CosmicProductsBannerType'
import type { CMSError } from '@/lib/cms/types/CMSError'
import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import Image from 'next/image'

type Props = {
  productsBannerImageData: CosmicBannerDataType | { error: CMSError } | null
}

export const ProductsBanner = ({ productsBannerImageData }: Props) => {
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()

  if (!productsBannerImageData) return null
  if ('error' in productsBannerImageData) {
    return (
      <div className="w-full">
        <ErrorAlert
          error={{
            error: {
              message: productsBannerImageData.error.message,
              code: productsBannerImageData.error.code,
            },
          }}
        />
      </div>
    )
  }

  if (
    !productsBannerImageData.bannerImageDesktop ||
    !productsBannerImageData.bannerImageMobile
  ) {
    return null
  }

  return (
    <a
      href={parseLinkUrlWithLocale({
        url: productsBannerImageData.urlPath,
      })}
      className="max-w-[2048px] flex-1"
    >
      <Image
        src={productsBannerImageData.bannerImageDesktop}
        alt={productsBannerImageData.altText}
        fill
        sizes="100vw"
        className="!relative hidden sm:block"
        priority
      />

      <Image
        src={productsBannerImageData.bannerImageMobile}
        alt={productsBannerImageData.altText}
        fill
        sizes="100vw"
        className="!relative block sm:hidden"
        priority
      />
    </a>
  )
}
